import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, onMounted, computed, type Component } from "vue";
import SuccessIcon from "../icons/SuccessIcon.vue";
import InfoIcon from "../icons/InfoIcon.vue";
import WarningIcon from "../icons/WarningIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
import CloseIcon from "../icons/CloseIcon.vue";

interface PropsI {
  status: "success" | "info" | "warning" | "error";
  text: string;
  width?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastPopup',
  props: {
    status: {},
    text: {},
    width: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;




const dynamicIcon = ref<null | Component>(null);

onMounted(() => {
  switch (props.status) {
    case "success":
      dynamicIcon.value = SuccessIcon;
      break;

    case "info":
      dynamicIcon.value = InfoIcon;
      break;

    case "warning":
      dynamicIcon.value = WarningIcon;
      break;

    case "error":
      dynamicIcon.value = ErrorIcon;
      break;
  }
});

const handleClick = () => {
  emit("close");
};

const classes = computed(() => `${props.status} ${props.width ? `w-[${props.width}px]` : 'w-1/3'}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["absolute z-50 right-12 flex items-center gap-2 px-3 py-4 rounded-lg text-sm shadow-secondary", classes.value])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(dynamicIcon.value))),
    _createElementVNode("p", { innerHTML: _ctx.text }, null, 8, _hoisted_1),
    _createVNode(CloseIcon, {
      class: "ml-auto cursor-pointer active:opacity-80",
      onClick: handleClick
    })
  ], 2))
}
}

})